<template>
<div>健康状态</div>
</template>

<script>
export default {
  name: 'healthManage'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/healthManage.vue